module.exports = __webpack_public_path__ + "img/arrow-up.c2262def.svg";